module.exports = __webpack_public_path__ + "static/media/ImgReceptionSmallEn.ea86d20f.svg";